module.exports = __webpack_public_path__ + "static/couture06-sq-8b265862779d485aacb642c7a48a6781.png";